import React from "react";
import PublishEvent from "./publishEvent"
import Expansion from "components/Expansion";
import { parseDateToString } from "../../util";
import Typography from "storybookComponents/Typography";
import Icon from "storybookComponents/Icon";
import Button from "storybookComponents/Button"
import { getMinValidDate } from "../../util";

const SentMessage = ({ classes, date, isApprover }) => {
  return (
    <div className={classes.rightPart}>
      <div className={classes.flexBox}>
        <Icon type=" icon-n-check" className={classes.sentSuccess} />
        <Typography type="body1">{date}</Typography>&nbsp;
      </div>
      {!isApprover ? <div className={classes.sendForApproval}>Sent for Approval</div> : null}
    </div>
  );
};
const PublishEventOnWebsite = ({
  classes,
  expanded,
  id,
  publishAt,
  handleExpandedPanel,
  onClick,
  getSubmitButtonState,
  ...props
}) => {
  const [minValidDate, setMinValidDate] = React.useState(
    getMinValidDate(props.timezoneString, props.userIsApprover)
  );
  const [date, setDate] = React.useState(publishAt ? publishAt : minValidDate);
  const handleDate = (date) => {
    setDate(date);
  };

  const handleRightSection = (open) => {
    if (publishAt && !open && date) {
      return (
        <SentMessage
          isApprover={props.userIsApprover}
          classes={classes}
          date={parseDateToString(date, props.timezoneString)}
        />
      );
    } else if (!open && date) {
      return (
        <div className={classes.rightPart}>{parseDateToString(date, props.timezoneString)}</div>
      );
    }
  };
  return (
    <Expansion
      expanded={expanded === "First"}
      name="First"
      handleExpandedPanel={handleExpandedPanel}
      header="Publish on Property Website"
      rightSection={handleRightSection}
      headerIcon={(open) =>
        publishAt && open ? <Icon type=" icon-n-check" className={classes.sentSuccess} /> : null
      }
    >
      <PublishEvent date={date} handleDate={handleDate} minValidDate={minValidDate} {...props} />
      <Button
        className={classes.button}
        state={getSubmitButtonState("publish")}
        onClick={onClick.bind(this, {
          id,
          publishDate: date.toISOString(),
        })}
        variant="primary"
        size="sm"
      >
        {props.userIsApprover ? (publishAt ? "Republish" : "Publish") : "Send For Approval"}
      </Button>
    </Expansion>
  );
};
export default PublishEventOnWebsite;